export function ResultsScreen({ results, timeSec, ptsEarned, onDone }) {
  const correct = results.filter(r => r.correct).length;
  const pct = Math.round((correct / results.length) * 100);
  const missed = results.filter(r => !r.correct);
  const color = pct >= 80 ? "var(--green)" : pct >= 60 ? "var(--amber)" : "var(--red)";
  const mins = Math.floor(timeSec / 60), secs = timeSec % 60;
  return (
    <div className="results-wrap">
      <div style={{ width: "100%", maxWidth: 500 }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "'Lora',serif", fontSize: "1.75rem", fontWeight: 700, color: "var(--navy)", marginTop: "1rem" }}>Test Complete!</div>
          <div className="score-ring" style={{ borderColor: color }}>
            <div className="score-big" style={{ color }}>{pct}%</div>
            <div className="score-frac">{correct}/{results.length}</div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: "1.75rem", marginBottom: "1rem", color: "var(--muted)", fontSize: ".87rem", fontWeight: 600 }}>
            <span>⏱ {mins}m {secs}s</span><span>✅ {correct} correct</span><span>❌ {missed.length} missed</span>
          </div>
          {ptsEarned > 0 && (
            <div style={{ textAlign: "center", marginBottom: "1.2rem" }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: ".5rem", background: "var(--amber-light)", color: "var(--amber)", fontWeight: 800, fontSize: "1rem", padding: ".55rem 1.25rem", borderRadius: 999 }}>
                ⭐ +{ptsEarned} points earned!
              </div>
            </div>
          )}
        </div>
        {missed.length > 0 ? (
          <div className="card">
            <div className="card-title">Words to Review</div>
            <div className="card-sub" style={{ marginBottom: ".9rem" }}>These will appear more often next time</div>
            <ul className="missed-list">
              {missed.map((r, i) => (
                <li key={i} className="missed-item">
                  <span className="m-wrong">{r.userAnswer}</span>
                  <span style={{ color: "var(--muted)" }}>→</span>
                  <span className="m-right">{r.word.word}</span>
                </li>
              ))}
            </ul>
          </div>
        ) : <div style={{ textAlign: "center", padding: "1.5rem 0" }}><div style={{ fontSize: "4rem" }}>🎉</div><div style={{ fontWeight: 800, color: "var(--green)", marginTop: ".5rem" }}>Perfect score!</div></div>}
        <button className="done-btn" style={{ width: "100%" }} onClick={onDone}>Back to Home</button>
      </div>
    </div>
  );
}
